import type { GetPackagesResult } from '@lib/packages/types/get-packages-result';

export async function fetchFirstPackageIdForDeal(
  dealId: string
): Promise<string> {
  const params = new URLSearchParams();
  params.set('dealId', dealId);
  params.set('orderBy', 'created_at');
  params.set('ascending', 'true');
  params.set('limit', '5');

  const response = await fetch(`/api/packages?${params.toString()}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch packages: ${response.statusText}`);
  }

  const data = (await response.json()) as GetPackagesResult;
  const first = data.items.at(0);
  if (!first?.id) {
    throw new Error('No package found for deal');
  }
  return first.id;
}
